import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_EHRFlowsheetConfiguration } from '@app/org-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onEHRFlowsheetConfigurationsUpdated = new ThunderDispatcherV3('__onEHRFlowsheetConfigurationsUpdated');
export class ModuleFE_EHRFlowsheetConfiguration_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EHRFlowsheetConfiguration, dispatch_onEHRFlowsheetConfigurationsUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_EHRFlowsheetConfiguration = new ModuleFE_EHRFlowsheetConfiguration_Class();
//# sourceMappingURL=ModuleFE_EHRFlowsheetConfiguration.js.map